/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   helper methods for messages
 */

export type MessageField = 'email' | 'moveIn' | 'name' | 'phone'

/**
 * Gets the fields that have been filled in message data
 *
 * @param messageData
 */
export const getFilledFields = (
  messageData: {
    [field in MessageField]?: unknown
  }
): MessageField[] => {
  const filledFields: MessageField[] = []
  const messageFields = ['email', 'moveIn', 'name', 'phone'] as const
  for (const field of messageFields) {
    if (messageData[field]) {
      filledFields.push(field)
    }
  }
  return filledFields
}
